import { render, staticRenderFns } from "./MarketInterest.vue?vue&type=template&id=4a3ca4b2"
import script from "./MarketInterest.vue?vue&type=script&lang=js"
export * from "./MarketInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports